// extracted by mini-css-extract-plugin
module.exports = {"hero":"solutions--hero--34By8","images":"solutions--images--Pkrq_","groupPeople":"solutions--groupPeople--3v8up","singleInView":"solutions--singleInView--2Xf0b"};